import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ISelectOption, LsqValidators, forLifeOf } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'invite-user-modal',
    styleUrls: ['./invite-user-modal.component.scss'],
    templateUrl: './invite-user-modal.component.html'
})
export class InviteUserModalComponent {
    @Input() formGroup: FormGroup;
    @Input() isInviteUser: boolean;
}
